import React from 'react';
import { connect } from 'react-redux';
// utils
import { Translations } from '../../../../utils/';
// constant
import { FORM_REFS } from '../../../../constants';
// restClient
import { aemHostClient, eapiClient } from '../../../../restClient';
// children
import Dynamicform from '../../../common/Dynamicform/dynamicForm';
import { blockUi, unBlockUi } from '../../../../actions/actionCreator';

//style
import './styles.css';
import { setPersons } from '../../actions/actionCreator';

class CreateAchContact extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentWillMount() {
    this.props.blockUi();
    let apiURL = "/aemData/formData/json_create-ach-credit-contact";
    if (this.props.mode === "edit") {
      apiURL = apiURL.replace("create-", "edit-");
    }
    aemHostClient(apiURL)
      .then(({ data }) => {
        document.title = `${data.title} - ${'HSBC GLCM'}`;
        this.setState({ formJson: data });
        this.props.unBlockUi();
      });
  }

  getFormData = (formData) => {
    this.setState({ formData });
  }

  onFormSubmit = (event, apiURL) => {
    this.props.blockUi();
    var requestData = {
      ...this.state.formData,
      caseId: this.props.caseId
    };
    requestData.entityId = this.props.entityId;
    if (this.props.mode === 'edit') {
      apiURL = apiURL + "/" + this.state.formData.id;
    }

    var METHOD = this.props.mode === 'edit' ? 'PUT' : 'POST';
    eapiClient(apiURL, {
      method: METHOD,
      data: JSON.stringify(requestData)
    })
      .then(({ data }) => {
        var key = window.sessionStorage.getItem("getCurrentDropDown");
        window.sessionStorage.setItem('key' + key, data.responseData.id);

        if (Array.isArray(this.props.persons)) {
          if (this.props.mode === 'edit') {
            const index = (Array.isArray(this.props.persons) && this.props.persons.length) ? this.props.persons.findIndex(person => person.id === data.responseData.id) : -1
            if (index < 0) {
              this.props.setPersons([...this.props.persons, { id: data.responseData.id, telephoneNumber: data.responseData.telephoneNumber, emailAddress: data.responseData.emailAddress, isUpdated: true }])
            }
            else if (index > -1) {
              const personList = this.props.persons
              personList[index] = { ...personList[index], telephoneNumber: data.responseData.telephoneNumber, emailAddress: data.responseData.emailAddress, isUpdated: true }
              this.props.setPersons(personList)
            }
          }
          else {
            this.props.setPersons([...this.props.persons, { id: data.responseData.id, telephoneNumber: data.responseData.telephoneNumber, emailAddress: data.responseData.emailAddress, isUpdated: true }])
          }
        }
        else {
          this.props.setPersons([{ id: data.responseData.id, telephoneNumber: data.responseData.telephoneNumber, emailAddress: data.responseData.emailAddress, isUpdated: true }])
        }

        this.props.history.goBack();
        this.props.unBlockUi();
      });
  }

  onFormCancel = () => {
    this.props.history.goBack();
  }

  renderFormGroups() {
    let formData;
    if (this.props.currentProductAch !== undefined) {
      formData = { ...this.props.currentProductAch };
    } else {
      formData = {};
    }
    const properties = {
      contactId: this.props.match.params.contactId,
      contactType: this.props.match.params.contactType,
      formData,
      editType: 'create-ach-contact',
      pathname: this.props.history.location.pathname
    };
    if (this.state.formJson !== undefined && this.state.formJson.par.aemform_ !== undefined) {
      return (
        <Dynamicform mode={this.props.mode}
          properties={properties}
          url={FORM_REFS[this.state.formJson.par.aemform_.formRef]}
          getFormData={this.getFormData}
          history={this.props.history}
          match={this.props.match}
          onFormSubmit={this.onFormSubmit}
          onFormCancel={this.onFormCancel}
          lang={this.props.lang.currentLang.lang}
          translatedData={this.props.lang.translatedData}
          flag={this.props.lang.currentLangFlag.flag}
        />
      );
    }
  }

  render() {
    const pageTitle = this.state.formJson ? this.state.formJson.par.page_title_mainTitle : '';
    return (
      <div className="form-container">
        <div className="form-title">
          <h2 className="form-heading">
            {Translations(pageTitle.pageHeading, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
          </h2>
          <p className="form-required-desc">
            {Translations(pageTitle.descriptionText, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
          </p>
        </div>
        {this.renderFormGroups()}
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  let currentProductAch = undefined;
  if (props.match.params) {
    var { contactId } = props.match.params;
    if (contactId && state.persons.length > 0) {
      state.persons.forEach(achContact => {
        if (achContact.id === contactId) {
          currentProductAch = achContact;
        }
      });
    }
  }
  return {
    currentProductAch,
    mode: currentProductAch !== undefined ? 'edit' : '',
    caseId: state.cases[state.currentProductAch.data.formData.caseId].caseId,
    entityId: state.cases[state.currentProductAch.data.formData.caseId].entityId,
    lang: state.lang,
    persons: state.persons
  };
}

const mapDispatchToProps = dispatch => {
  return {
    blockUi: () => {
      dispatch(blockUi())
    },
    unBlockUi: () => {
      dispatch(unBlockUi())
    },
    setPersons: persons => {
      dispatch(setPersons(persons));
    }
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(CreateAchContact);



// WEBPACK FOOTER //
// ./src/components/CaseBody/ProductRequests/CaptureProductAchCredit/createAchContact.js